/*
 * Password reset Reducer
 */

import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_ERROR,
  GRANT_PASSWORD_RESET_PRIVILEGE,
  GRANT_PASSWORD_RESET_PRIVILEGE_SUCCESS,
  GRANT_PASSWORD_RESET_PRIVILEGE_ERROR,
  PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
} from './../actions/PasswordReset';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, fromJS } from 'immutable';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

const PasswordResetStateRecord = Record({
  isLoading: false,
  privilegeCheckLoading: true,
  hasPasswordChangePrivilege: false,
  actionResponse: null,
});

const passwordReset = (state = new PasswordResetStateRecord({}), action) => {
  switch (action.type) {
    case PASSWORD_RESET_REQUEST:
      return passwordResetRequest(state);
    case PASSWORD_RESET_REQUEST_SUCCESS:
      return passwordResetRequestSuccess(state, action);
    case PASSWORD_RESET_REQUEST_ERROR:
      return passwordResetRequestError(state, action);

    case GRANT_PASSWORD_RESET_PRIVILEGE:
      return grantPasswordResetPrivilege(state);
    case GRANT_PASSWORD_RESET_PRIVILEGE_SUCCESS:
      return grantPasswordResetPrivilegeSuccess(state, action);
    case GRANT_PASSWORD_RESET_PRIVILEGE_ERROR:
      return grantPasswordResetPrivilegeError(state, action);

    case PASSWORD_RESET:
      return sendPasswordReset(state);
    case PASSWORD_RESET_SUCCESS:
      return sendPasswordResetSuccess(state, action);
    case PASSWORD_RESET_ERROR:
      return sendPasswordResetError(state, action);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

const passwordResetRequest = (state) => {
  return state.setIn(['isLoading'], true);
};

const passwordResetRequestSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const passwordResetRequestError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const grantPasswordResetPrivilege = (state) => {
  return state.setIn(['privilegeCheckLoading'], true).setIn(['hasPasswordChangePrivilege'], false);
};

const grantPasswordResetPrivilegeSuccess = (state, action) => {
  return state
    .setIn(['privilegeCheckLoading'], false)
    .setIn(['hasPasswordChangePrivilege'], true)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const grantPasswordResetPrivilegeError = (state, action) => {
  return state
    .setIn(['privilegeCheckLoading'], false)
    .setIn(['hasPasswordChangePrivilege'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const sendPasswordReset = (state) => {
  return state.setIn(['isLoading'], true);
};

const sendPasswordResetSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const sendPasswordResetError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default passwordReset;
